var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ElectionHeader from "@/components/ElectionHeader";
import { ListActions } from "@/components/ListActions";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { Box, Alert, styled, Typography, Button, Drawer, CircularProgress, } from "@mui/material";
import { useContext, useEffect, useMemo, useState } from "react";
import { DatagridConfigurable, FunctionField, List, useGetList, useSidebarState, useDataProvider, useNotify, useGetOne, TextField, TextInput as FilterTextInput, useRefresh, WrapperField, SelectInput, } from "react-admin";
import { useTranslation } from "react-i18next";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { CustomApolloContextProvider } from "@/providers/ApolloContextProvider";
import EditIcon from "@mui/icons-material/Edit";
import { IconButton as IconButtonSequent } from "@sequentech/ui-essentials";
import LockIcon from "@mui/icons-material/Lock";
import NoEncryptionGmailerrorredIcon from "@mui/icons-material/NoEncryptionGmailerrorred";
import { EditReportForm, EReportEncryption } from "./EditReportForm";
import DeleteIcon from "@mui/icons-material/Delete";
import DescriptionIcon from "@mui/icons-material/Description";
import PreviewIcon from "@mui/icons-material/Preview";
import { Dialog } from "@sequentech/ui-essentials";
import { EGenerateReportMode, EReportType, ReportActions, reportTypeConfig } from "@/types/reports";
import { GENERATE_REPORT } from "@/queries/GenerateReport";
import { useMutation } from "@apollo/client";
import { DownloadDocument } from "../User/DownloadDocument";
import { ListActionsMenu } from "@/components/ListActionsMenu";
import { useWidgetStore } from "@/providers/WidgetsContextProvider";
import { ETasksExecution } from "@/types/tasksExecution";
import { useReportsPermissions } from "./useReportsPermissions";
import { ThreeStateDatagridHeader } from "@/components/ThreeStateDatagridHeader";
import { useSignedAction } from "@/hooks/useSignedAction";
import { GenerateSignedReportDialog, ReportSignaturesCell, ReportRequestLinks, heldByReports, useReportSignatures, useReportTaskSigningRequest, } from "./ReportSigning";
var DataGridContainerStyle = styled(DatagridConfigurable)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    @media (min-width: ", "px) {\n        overflow-x: auto;\n        width: 100%;\n        ", "\n        &  > div:first-child {\n            position: absolute;\n            width: 100%;\n        }\n    }\n"], ["\n    @media (min-width: ", "px) {\n        overflow-x: auto;\n        width: 100%;\n        ", "\n        &  > div:first-child {\n            position: absolute;\n            width: 100%;\n        }\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.values.md;
}, function (_a) {
    var isOpenSideBar = _a.isOpenSideBar;
    return "max-width: ".concat(isOpenSideBar ? "calc(100vw - 355px)" : "calc(100vw - 108px)", ";");
});
var TemplateEmpty = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    width: 100%;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    width: 100%;\n"])));
var ActionsPopUp = function (_a) {
    var actions = _a.actions, report = _a.report, canWriteReport = _a.canWriteReport;
    var filteredActions = useMemo(function () {
        var reportConfig = reportTypeConfig[report.report_type];
        var offered = function (key) { return !!(reportConfig === null || reportConfig === void 0 ? void 0 : reportConfig.actions.includes(key)); };
        var isShowAction = function (action) {
            return (!action.key ||
                !offered(action.key) ||
                ((action.key === ReportActions.EDIT || action.key === ReportActions.DELETE) &&
                    !canWriteReport));
        };
        return actions.filter(function (action) { return !isShowAction(action); });
    }, [report]);
    return _jsx(ListActionsMenu, { actions: filteredActions });
};
// filter by permission-labels
export { reportDecryptionCommand as decryptionCommand } from "./ReportPasswordDialog";
var ListReports = function (_a) {
    var _b;
    var electionEventId = _a.electionEventId;
    var t = useTranslation().t;
    var _c = useState(false), openCreateReport = _c[0], setOpenCreateReport = _c[1];
    var isOpenSidebar = useSidebarState()[0];
    var _d = useState(undefined), documentId = _d[0], setDocumentId = _d[1];
    var _e = useState([]), electionList = _e[0], setElectionList = _e[1];
    var _f = useState(null), selectedReportId = _f[0], setSelectedReportId = _f[1];
    var globalSettings = useContext(SettingsContext).globalSettings;
    var _g = useWidgetStore(), addWidget = _g[0], setWidgetTaskId = _g[1], updateWidgetFail = _g[2];
    var tenantId = useTenantStore()[0];
    var authContext = useContext(AuthContext);
    var notify = useNotify();
    var refresh = useRefresh();
    var aliasRenderer = useAliasRenderer();
    var report = useGetOne("sequent_backend_report", {
        id: selectedReportId,
    }, {
        enabled: !!selectedReportId,
        refetchInterval: globalSettings.QUERY_POLL_INTERVAL_MS,
    }).data;
    var _h = useReportsPermissions(), canReadReports = _h.canReadReports, canWriteReports = _h.canWriteReports, canCreateReports = _h.canCreateReports, canDeleteReports = _h.canDeleteReports, canGenerateReports = _h.canGenerateReports, canPreviewReports = _h.canPreviewReports, showReportsColumns = _h.showReportsColumns;
    var generateReport = useMutation(GENERATE_REPORT, {
        context: {
            headers: {
                "x-hasura-role": IPermissions.REPORT_READ,
            },
        },
    })[0];
    // const canWriteReport = authContext.isAuthorized(true, tenantId, IPermissions.REPORT_WRITE)
    var _j = useState(false), openDeleteModal = _j[0], setOpenDeleteModal = _j[1];
    var dataProvider = useDataProvider();
    var handleClose = function () {
        refresh();
        setOpenCreateReport(false);
        setSelectedReportId(null);
        setOpenDeleteModal(false);
    };
    var fileName = useMemo(function () {
        if (report) {
            var electionId = report.election_id;
            var electionEventId_1 = report.election_event_id;
            var reportType = report.report_type;
            return "".concat(reportType, "_").concat(electionId, "_").concat(electionEventId_1);
        }
        else {
            return "";
        }
    }, [report]);
    var handleEditDrawer = function (id) {
        setSelectedReportId(id);
        setOpenCreateReport(true);
        setOpenDeleteModal(false);
    };
    var deleteReport = function (id) {
        setOpenDeleteModal(true);
        setOpenCreateReport(false);
        setSelectedReportId(id);
    };
    // With its action's rule Required, a report the Reports tab generates
    // waits for signatures: the dialog says so, and its task names the
    // request whose panel opens (with what the released report offers).
    var signatures = useReportSignatures(electionEventId);
    var openSigned = useSignedAction();
    var _k = useState(null), signedGenerate = _k[0], setSignedGenerate = _k[1];
    var _l = useState(false), reportScopeError = _l[0], setReportScopeError = _l[1];
    var _m = useState(null), reportTaskId = _m[0], setReportTaskId = _m[1];
    var reportSigningRequest = useReportTaskSigningRequest(reportTaskId);
    useEffect(function () {
        if (!reportSigningRequest)
            return;
        // Nothing to download before the signatures: the panel says what waits.
        setReportTaskId(null);
        setDocumentId(undefined);
        openSigned({ signing_request: { id: reportSigningRequest } });
    }, [reportSigningRequest]);
    var startGenerateReport = function (id, mode) { return __awaiter(void 0, void 0, void 0, function () {
        var record, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setReportScopeError(false);
                    if (!(mode === EGenerateReportMode.REAL && signatures.known)) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, dataProvider.getOne("sequent_backend_report", { id: id })];
                case 2:
                    record = (_b.sent()).data;
                    if (heldByReports(record.report_type) && signatures.needs(record.report_type)) {
                        if (!record.election_id) {
                            setReportScopeError(true);
                            return [2 /*return*/];
                        }
                        setSignedGenerate(record);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 4: return [4 /*yield*/, handleGenerateReport(id, mode)];
                case 5:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleGenerateReport = function (id, mode) { return __awaiter(void 0, void 0, void 0, function () {
        var currWidget, generateReportResponse, response, taskId, generatedDocumentId, e_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setDocumentId(undefined);
                    currWidget = addWidget(ETasksExecution.GENERATE_REPORT, undefined);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, generateReport({
                            variables: {
                                reportId: id,
                                tenantId: tenantId,
                                reportMode: mode,
                                electionEventId: electionEventId,
                            },
                        })];
                case 2:
                    generateReportResponse = _c.sent();
                    response = (_a = generateReportResponse.data) === null || _a === void 0 ? void 0 : _a.generate_report;
                    taskId = (_b = response === null || response === void 0 ? void 0 : response.task_execution) === null || _b === void 0 ? void 0 : _b.id;
                    generatedDocumentId = response === null || response === void 0 ? void 0 : response.document_id;
                    if (!generatedDocumentId) {
                        updateWidgetFail(currWidget.identifier);
                        setSelectedReportId(null);
                        setDocumentId(undefined);
                        return [2 /*return*/];
                    }
                    setDocumentId(generatedDocumentId);
                    setWidgetTaskId(currWidget.identifier, taskId);
                    setReportTaskId(taskId !== null && taskId !== void 0 ? taskId : null);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _c.sent();
                    updateWidgetFail(currWidget.identifier);
                    setSelectedReportId(null);
                    setDocumentId(undefined);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var templates = useGetList("sequent_backend_template", {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "created_at", order: "DESC" },
        filter: {
            tenant_id: tenantId,
        },
    }, {
        refetchInterval: globalSettings.QUERY_POLL_INTERVAL_MS,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
    }).data;
    var elections = useGetList("sequent_backend_election", {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "created_at", order: "DESC" },
        filter: {
            tenant_id: tenantId,
            election_event_id: electionEventId,
        },
    }, {
        refetchInterval: globalSettings.QUERY_POLL_INTERVAL_MS,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
    }).data;
    var listFilter = useMemo(function () {
        var ids = elections === null || elections === void 0 ? void 0 : elections.map(function (election) { return election.id; });
        if (undefined !== ids && electionList !== ids) {
            setElectionList(ids);
        }
        var filter = {
            election_event_id: electionEventId,
            tenant_id: tenantId,
            _or: {
                format: "hasura-raw-query",
                value: [
                    {
                        election_id: { _in: ids !== null && ids !== void 0 ? ids : [] },
                    },
                    {
                        election_id: { _is_null: true },
                    },
                ],
            },
        };
        return filter;
    }, [electionEventId, tenantId, elections]);
    var OMIT_FIELDS = ["id"];
    var Filters = [
        _jsx(SelectInput, { source: "report_type", label: String(t("reportsScreen.fields.reportType")), choices: Object.values(EReportType).map(function (eventType) { return ({
                id: eventType,
                name: t("template.type.".concat(eventType)),
            }); }) }, "event_processor_filter"),
        _jsx(SelectInput, { source: "election_id", label: String(t("reportsScreen.fields.electionId")), choices: elections === null || elections === void 0 ? void 0 : elections.map(function (election) { return ({
                id: election.id,
                name: aliasRenderer(election),
            }); }) }, "election_id_filter"),
        _jsx(FilterTextInput, { label: "Template", source: "template_alias" }, 0),
    ];
    var handleCreateDrawer = function () {
        setSelectedReportId(null);
        setOpenCreateReport(true);
    };
    var CreateButton = function () { return (_jsxs(Button, { onClick: handleCreateDrawer, children: [_jsx(IconButtonSequent, { icon: faPlus, fontSize: "24px" }), t("reportsScreen.empty.button")] })); };
    var ReportEmpty = function () {
        return (_jsxs(TemplateEmpty, { children: [_jsx(Typography, { variant: "h4", children: t("reportsScreen.empty.header") }), canCreateReports && (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "body1", paragraph: true, children: t("reportsScreen.empty.body") }), _jsx(CreateButton, {})] }))] }));
    };
    var confirmDeleteAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedReportId) return [3 /*break*/, 2];
                    return [4 /*yield*/, dataProvider.delete("sequent_backend_report", {
                            id: selectedReportId,
                        })];
                case 1:
                    _a.sent();
                    handleClose();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var renderDeleteModal = function () {
        return (_jsx(Dialog, { variant: "warning", open: openDeleteModal, ok: String(t("common.label.delete")), cancel: String(t("common.label.cancel")), title: String(t("common.label.warning")), handleClose: function (result) {
                if (result) {
                    confirmDeleteAction();
                }
                setOpenDeleteModal(false);
            }, children: t("reportsScreen.delete.body") }));
    };
    var getTemplateName = function (report) {
        var _a;
        var templateAlias = report.template_alias;
        var template = templates === null || templates === void 0 ? void 0 : templates.find(function (template) { return template.alias === templateAlias; });
        return (_a = template === null || template === void 0 ? void 0 : template.template.name) !== null && _a !== void 0 ? _a : "-";
    };
    var getElectionName = function (report) {
        var electionId = report.election_id;
        if (!electionId)
            return "-";
        var foundElection = elections === null || elections === void 0 ? void 0 : elections.find(function (election) { return election.id === electionId; });
        return (foundElection && aliasRenderer(foundElection)) || "-";
    };
    var getEncryptionPolicy = function (report) {
        return report.encryption_policy === EReportEncryption.CONFIGURED_PASSWORD ? (_jsx(LockIcon, {})) : (_jsx(NoEncryptionGmailerrorredIcon, {}));
    };
    var actions = [
        {
            key: ReportActions.EDIT,
            icon: _jsx(EditIcon, {}),
            action: handleEditDrawer,
            showAction: function () { return canWriteReports; },
            label: t("reportsScreen.actions.edit"),
        },
        {
            key: ReportActions.DELETE,
            icon: _jsx(DeleteIcon, {}),
            action: deleteReport,
            showAction: function () { return canDeleteReports; },
            label: t("reportsScreen.actions.delete"),
        },
        {
            key: ReportActions.GENERATE,
            icon: _jsx(DescriptionIcon, {}),
            action: function (id) {
                void startGenerateReport(id, EGenerateReportMode.REAL);
            },
            showAction: function () { return canGenerateReports; },
            label: t("reportsScreen.actions.generate"),
        },
        {
            key: ReportActions.PREVIEW,
            icon: _jsx(PreviewIcon, {}),
            action: function (id) {
                handleGenerateReport(id, EGenerateReportMode.PREVIEW);
            },
            showAction: function () { return canPreviewReports; },
            label: t("reportsScreen.actions.preview"),
        },
    ];
    var renderDownloadDocumentHelper = function () {
        if (!documentId) {
            return null;
        }
        return (_jsx(DownloadDocument, { onDownload: function () {
                setDocumentId(undefined);
                setSelectedReportId(null);
            }, fileName: fileName, showReportPasswordDialog: true, documentId: documentId, electionEventId: electionEventId }));
    };
    if (!elections) {
        return _jsx(CircularProgress, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(ElectionHeader, { title: String(t("reportsScreen.title")), subtitle: String(t("reportsScreen.subtitle")) }), reportScopeError && (_jsx(Alert, { severity: "warning", sx: { mb: 2 }, children: t("signing.reports.postRequired") })), _jsx(List, { resource: "sequent_backend_report", filter: listFilter, filters: Filters, queryOptions: {
                    refetchInterval: globalSettings.QUERY_POLL_INTERVAL_MS,
                }, empty: _jsx(ReportEmpty, {}), actions: _jsx(ListActions, { custom: true, withColumns: showReportsColumns, withImport: false, withExport: false, withFilter: true, open: openCreateReport, setOpen: setOpenCreateReport, withAction: canCreateReports, doAction: function () { return setOpenCreateReport(true); }, actionLabel: "common.label.add" }), disableSyncWithLocation: true, children: _jsxs(DataGridContainerStyle, { header: ThreeStateDatagridHeader, isOpenSideBar: isOpenSidebar, omit: OMIT_FIELDS, rowClick: false, children: [_jsx(TextField, { source: "id" }), _jsx(FunctionField, { label: String(t("reportsScreen.fields.reportType")), source: "report_type", render: function (record) {
                                return t("template.type." + record.report_type);
                            } }), _jsx(FunctionField, { label: String(t("reportsScreen.fields.template")), source: "template_alias", render: getTemplateName }), _jsx(FunctionField, { label: String(t("reportsScreen.fields.electionId")), source: "election_id", render: getElectionName }), _jsx(FunctionField, { label: String(t("signing.results.signatures")), render: function (record) { return (_jsxs(_Fragment, { children: [_jsx(ReportSignaturesCell, { needs: signatures.needs(record.report_type) }), _jsx(ReportRequestLinks, { electionEventId: electionEventId, reportType: record.report_type, electionId: record.election_id, reportId: record.id })] })); } }), _jsx(FunctionField, { label: "encryption", source: "encryption_policy", render: getEncryptionPolicy }), !canWriteReports &&
                            !canDeleteReports &&
                            !canGenerateReports &&
                            !canPreviewReports ? null : (_jsx(WrapperField, { label: "Actions", children: _jsx(FunctionField, { render: function (record) { return (_jsx(ActionsPopUp, { actions: actions, report: record, canWriteReport: canWriteReports })); } }) }))] }) }), _jsx(Drawer, { anchor: "right", open: openCreateReport, onClose: handleClose, PaperProps: {
                    sx: { width: "40%" },
                }, children: _jsx(CustomApolloContextProvider, { role: IPermissions.template_WRITE, children: _jsx(EditReportForm, { close: handleClose, electionEventId: electionEventId, tenantId: tenantId, isEditReport: !!selectedReportId, reportId: selectedReportId }) }) }), renderDeleteModal(), renderDownloadDocumentHelper(), signedGenerate ? (_jsx(GenerateSignedReportDialog, { open: true, title: String(t("template.type.".concat(signedGenerate.report_type))), post: getElectionName(signedGenerate), needs: (_b = signatures.needs(signedGenerate.report_type)) !== null && _b !== void 0 ? _b : 0, onClose: function (generate) {
                    var report = signedGenerate;
                    setSignedGenerate(null);
                    if (generate) {
                        void handleGenerateReport(report.id, EGenerateReportMode.REAL);
                    }
                } })) : null] }));
};
export default ListReports;
var templateObject_1, templateObject_2;
